
  import Events from '@/events/Events';
  import ProfileIncomplete from '@/mixins/ProfileIncomplete';
  export default {
    mixins: [ProfileIncomplete],
    props: {
      buttonText: {
        type: String,
        required: false,
        default: () => '',
      },
      eventType: {
        type: String,
        required: false,
        default: 'NULL',
      },
    },
    methods: {
      redirectToUserProfile() {
        this.$router.push(this.url);
        this.$emitWithClientData(Events.ThankYouSwitchToProfileComplete, {
          type: this.eventType,
        });
      },
    },
  };
